/**
 * Mirrors the backend's App\Enum\CompetitionAttendanceStatus::ALL — the
 * frontend never infers attendance, but it DOES need this list to populate
 * the status dropdown/filter and to map a status to its StatusBadge key.
 * Adding a future status needs only a new entry here + a translation key +
 * a new StatusBadge.STATUSES entry — no other frontend code changes.
 */
export const attendance = {
  DEFAULT_STATUS: 'PRESENT',
  STATUSES: [
    { value: 'PRESENT', badgeKey: 'present' },
    { value: 'ABSENT', badgeKey: 'absent' },
    { value: 'WITHDRAWN', badgeKey: 'withdrawn' },
    { value: 'DISQUALIFIED', badgeKey: 'disqualified' },
    { value: 'MEDICAL_WITHDRAWAL', badgeKey: 'medicalWithdrawal' },
  ],
};

export const attendanceStatusToBadgeKey = status => {
  const entry = attendance.STATUSES.find(s => s.value === status);
  return entry ? entry.badgeKey : null;
};

export const isPresentStatus = status => !status || status === attendance.DEFAULT_STATUS;

/**
 * The statuses that may cover only SOME categories — the backend's
 * CompetitionAttendanceStatus::PARTIAL (organiser, 8 Oct 2026): a withdrawal,
 * and a disqualification (from one event, or from all still to come while
 * those already performed count).
 */
export const PARTIAL_STATUSES = ['WITHDRAWN', 'MEDICAL_WITHDRAWAL', 'DISQUALIFIED'];

export const isPartialStatus = status => PARTIAL_STATUSES.includes(status);

/**
 * The status an attendance ROW gives an athlete in ONE category — or, with
 * `categoryId` null, in the competition as a whole. The backend's
 * AttendanceStatusResolver::covers(), read the same way: a withdrawal naming
 * other categories leaves this one PRESENT.
 */
export const statusInCategory = (row, categoryId = null) => {
  if (!row || isPresentStatus(row.status)) {
    return attendance.DEFAULT_STATUS;
  }
  const categories = isPartialStatus(row.status) ? (row.withdrawnCategories || null) : null;
  if (null === categories || (categoryId && categories.includes(categoryId))) {
    return row.status;
  }

  return attendance.DEFAULT_STATUS;
};
